import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const footerLinks = {
  navigation: [
    { name: '首页', href: '/' },
    { name: '明星塌房', href: '/category/star-collapse' },
    { name: '网红黑料', href: '/category/wanghong-expose' },
    { name: '每日大赛', href: '/category/daily-contest' },
    { name: '吃瓜视频', href: '/category/video-gossip' },
    { name: '独家爆料', href: '/category/exclusive-reveal' },
    { name: '黑料追踪', href: '/category/hot-tracking' },
  ],
  support: [
    { name: '关于我们', href: '/about' },
    { name: '品牌介绍', href: '/about' },
    { name: '用户口碑', href: '/about' },
    { name: '联系我们', href: '/about' },
  ],
  legal: [
    { name: '用户协议', href: '#' },
    { name: '隐私政策', href: '#' },
    { name: '免责声明', href: '#' },
    { name: '投诉指引', href: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-600">
      <div className="mx-auto px-6 md:px-10 py-14 md:py-16 max-w-[1280px]">
        <div className="bg-secondary-500/60 rounded-2xl px-8 md:px-12 py-12 md:py-14">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="lg:w-1/4 flex-shrink-0">
              <Link to="/" className="inline-block">
                <span className="font-heading text-2xl font-black text-background-50 tracking-tight">51吃瓜网</span>
              </Link>
              <p className="mt-4 text-sm text-background-50/70 leading-relaxed max-w-xs">
                全网最新吃瓜资源与爆料入口，实时更新明星塌房、网红黑料、每日大赛等热门事件，吃瓜群众必看的信息集散地。
              </p>
            </div>

            <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-10">
              <div>
                <h4 className="text-xs font-semibold text-background-50/50 uppercase tracking-widest mb-4 font-label">热门栏目</h4>
                <ul className="space-y-2.5">
                  {footerLinks.navigation.slice(0, 5).map((link) => (
                    <li key={link.name}>
                      <Link to={link.href} className="text-sm text-background-50/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="text-xs font-semibold text-background-50/50 uppercase tracking-widest mb-4 font-label">关于本站</h4>
                <ul className="space-y-2.5">
                  {footerLinks.support.map((link) => (
                    <li key={link.name}>
                      <Link to={link.href} className="text-sm text-background-50/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="text-xs font-semibold text-background-50/50 uppercase tracking-widest mb-4 font-label">法律声明</h4>
                <ul className="space-y-2.5">
                  {footerLinks.legal.map((link) => (
                    <li key={link.name}>
                      <a href={link.href} className="text-sm text-background-50/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/50">
              &copy; 2026 51今日吃瓜网 All Rights Reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-50/80 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-50/80 text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}